import { httpPatch } from "../../../../../../common/network/fetch";

export const ValidateOperationDataCommandHandler = async (operationCode: string) => {
    return await httpPatch({ url: `/operations/reporting/${operationCode}/validate` }, false);
};
